import React from 'react';
import { graphql, withApollo } from 'react-apollo';
import {
  Input,
  Tooltip,
  notification,
  Button,
  Modal,
  Select,
  Divider,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import evaluarLicencia from '../../../../graphql/mutations/rrhh/evaluarLicencia.graphql';
import getLicencias from '../../../../graphql/querys/rrhh/getLicencias.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
const confirm = Modal.confirm;

@graphql(evaluarLicencia, {
  name: 'evaluarLicencia',
  options: {
    refetchQueries: [{ query: getLicencias }],
  },
})
class DatosEvaluacion extends React.Component {
  onSubmit = e => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.evaluarLicencia(values);
      }
    });
  };

  evaluarLicencia = valores => {
    // console.log("Estoy en el evaluar");
    // console.log(valores);

    let yo = this;
    confirm({
      title: '¿Realmente quiere confirmar y guardar?',
      content: `Al presionar aceptar, se enviará una copia de la licencia a la casilla de correo de Gestion Humana, con copia al email del solicitante, como asi tambien te enviaremos una copia a ti.`,
      onOk() {
        yo.props
          .evaluarLicencia({
            variables: {
              _id: yo.props.licencia._id,
              opinionSupervisor: valores.opinionSupervisor,
              observacionSupervisor: valores.observacionSupervisor
                ? valores.observacionSupervisor
                : '',
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Evaluacion guardada con exito',
              description:
                'Se ha registrado los nuevos datos de la evaluacion, y se enviaron los emails correspondientes.',
            });

            yo.props.history.push('/rrhh/licencias');
          })
          .catch(err => {
            console.log('Error en la confirmacion de la evaluacion');
            console.log(err);

            Modal.error({
              title: 'Error en la confirmacion de la evaluacion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Datos de la Evaluacion</h1>
        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Evaluacion
                <Tooltip title="Seleccione la evaluacion de la licencia">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('opinionSupervisor', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, seleccione la evaluacion',
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Evaluacion"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={'FAVORABLE'} value={'FAVORABLE'}>
                  FAVORABLE
                </Option>

                <Option key={'DESFAVORABLE'} value={'DESFAVORABLE'}>
                  DESFAVORABLE
                </Option>
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Observación
                <Tooltip title="Si lo desea, puede agregar algun comentario de la evaluacion">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observacionSupervisor', {})(
              <TextArea style={{ color: '#000000' }} rows={6} />
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit" style={{ marginLeft: 10 }}>
              Guardar y Enviar
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.historyg.goBack()}
              style={{ marginLeft: 10 }}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(withApollo(DatosEvaluacion));
